export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd62eac894f42ad2f2c1a63c4268e9a48b4dfc088&name=fetchTypeahead!'